// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

// var AutocompleteInput = require("./lib/autocomplete-input.js");
//
// console.log(AutocompleteInput);
//
// var input = document.querySelector("autocomplete-input");
// input.addEventListener("change", function(e) {
//   console.log(e.type, input.value);
// });

if (window.location.hash != ''){
  var startID = window.location.hash;
  startID = startID.replace("#", "");
  document.querySelector('#default').style.display = "none";
  document.querySelector(`#definitions li[data-id='${startID}']`).classList.add("selected");
  var startWord = document.querySelector(`#terms li[data-term='${startID}']`).innerText;
  document.querySelector("#myInput").value = startWord;

}else {}


function myFunction() {
  console.log("im searching");
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    ul = document.getElementById("terms");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
        a = li[i];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "block";
        } else {
            li[i].style.display = "none";
        }
    }
}


function checkKey(e) {

    e = e || window.event;
    if (e.keyCode == '38') {
        console.log('up');

    }
    else if (e.keyCode == '40') {
        console.log('down');
    } else {
      myFunction();
    }
}


document.querySelector("#myInput").addEventListener("keyup", () => checkKey());

document.querySelectorAll("#terms li").forEach(el => el.addEventListener('click', () => {
  // document.querySelectorAll('#terms li').forEach(el => el.style.display = "none" );
  document.querySelector('#default').style.display = "none";
  document.querySelector('#terms').style.display = "none";
  var chosenID = el.dataset.term;
  document.querySelector("#myInput").value = el.innerText;

  document.querySelectorAll('#definitions li').forEach(el => el.classList.remove("selected"));

  document.querySelector(`#definitions li[data-id='${chosenID}']`).classList.add("selected");
}));


// clear button //
document.querySelector(".search-container .fa-times-circle").addEventListener('click', () => {
  document.querySelector("#myInput").value = '';
  document.querySelector('#default').style.display = "block";
  document.querySelector('#terms').style.display = "none";
  // document.querySelectorAll('#terms li').forEach(el => el.style.display = "none" );
  document.querySelectorAll('#definitions li').forEach(el => el.classList.remove("selected"));
  window.location.hash = '';
  console.log(window.location.hash);
});


//search button //
document.querySelector(".search-container .fa-search").addEventListener('click', () => {
  // document.querySelectorAll('#terms li').forEach(el => el.style.display = "block" );
  document.querySelector('#terms').style.display = "block";
});

//text input click //
document.querySelector("#myInput").addEventListener('click', () => {
  // document.querySelectorAll('#terms li').forEach(el => el.style.display = "block" );
  document.querySelector('#terms').style.display = "block";
});
